import { NextPage } from 'next';
import React from 'react';
import ErrorPage from '../../../pages/_error';
import { LayoutProps } from '../../../types/LayoutTypes';
import ErrorBoundary from '../ErrorBoundary';

export type ErrorProps = { error: { statusCode?: number } };

// eslint-disable-next-line @typescript-eslint/ban-types
const withErrorPage = <T extends object>(WrappedPage: NextPage<T>) => {
  const isErrorProps = (props: T | ErrorProps): props is ErrorProps => 'error' in props;
  return ((props) => {
    if (isErrorProps(props)) {
      return <ErrorPage statusCode={props.error.statusCode} />;
    } else {
      return (
        <ErrorBoundary>
          <WrappedPage {...(props as T)} />
        </ErrorBoundary>
      );
    }
  }) as NextPage<T | ErrorProps> & { layoutProps: LayoutProps };
};

export default withErrorPage;
